import { IBackboneTourProduct } from '@ve/types/backboneModels/Domain/Entity/BackboneTourProduct';
import { HotelOffer } from '@ve/types/api/HotelOffer';
import { RailwayTour } from '@ve/types/railway/RailwayTour';
import { Tour } from '@ve/types';

export function processTourAdapter(tourProducts: IBackboneTourProduct[]): Tour[] {
    return tourProducts.map((torProduct) => ({
        operator: torProduct.get('tour').get('operator'),
        hotelAvailable: torProduct.get('tour').get('hotelAvailable'),
        flightType: torProduct.get('tour').get('flightType'),
        nights: torProduct.get('tour').get('nights'),
        checkInDate: torProduct.get('tour').get('checkInDate'),
        meal: torProduct.get('tour').get('meal'),
        departureCity: torProduct.get('tour').get('departureCity'),
        country: torProduct.get('tour').get('country'),
        hotel: torProduct.get('tour').get('hotel'),
        cashbackAvailable: torProduct.get('tour').get('cashbackAvailable'),
        price: torProduct.get('tour').get('price'),
        oilTax: torProduct.get('tour').get('oilTax'),
        routes: torProduct.get('tour').get('routes'),
        room: torProduct.get('tour').get('room'),
        touristGroup: torProduct.get('tour').get('touristGroup'),
        flightSpecificationPrice: torProduct.get('tour').get('flightSpecificationPrice'),
        freeCancellation: torProduct.get('tour').get('freeCancellation'),
        originalPrice: torProduct.get('tour').get('originalPrice'),
        sortRate: torProduct.get('tour')?.get('sortRate'),
        priceWithOilTax: torProduct.get('tour')?.get('priceWithOilTax'),
        id: torProduct.get('tour').get('id'),
        resort: torProduct.get('tour').get('resort'),
    }));
}
export function processHotelOfferAdapter(hotelOffers: Backbone.Model<HotelOffer>[]): Partial<HotelOffer>[] {
    return hotelOffers.map((hotelOffer) => ({
        operator: hotelOffer.get('operator'),
    }));
}
export function processRailwayTourAdapter(railwayTours: Backbone.Model<RailwayTour>[]): Partial<RailwayTour>[] {
    return railwayTours.map((railwayTour) => ({
        operator: railwayTour.get('operator'),
    }));
}